"use strict";
import { legend } from '../_config'
export const legendHelper={
  generateLegend,
}

function generateLegend(){
  const custom = L.Control.extend({
    options: {
      position: legend.position
    },
    onAdd: (map) =>{
      let status = false;
      let container = L.DomUtil.create('div','mb-3 ml-3 leyendaContainer')
      let infoContent = L.DomUtil.create('div','card oculto')

      let list = L.DomUtil.create('ul','list-group list-group-flush')

      let nodes = L.DomUtil.create('li','list-group-item li-item')
      let textNodes = L.DomUtil.create('span','li-content-text')
      let nodeImg = L.DomUtil.create('img', 'li-content-icon')
      nodeImg.src = (location.port === '8080') ? '../src/assets/img/marcador.svg' : 'assets/img/marcador.svg'
      nodeImg.style.width = '30px'
      textNodes.innerText = 'Nodos'
      nodes.appendChild(nodeImg)
      nodes.appendChild(textNodes)

      let start = L.DomUtil.create('li','list-group-item li-item')
      let textStart = L.DomUtil.create('span','li-content-text')
      let startImg = L.DomUtil.create('img', 'li-content-icon')
      startImg.src = (location.port === '8080') ? '../src/assets/img/start.svg' : 'assets/img/start.svg'
      startImg.style.width = '30px'
      textStart.innerText = 'Nodo de inicio de ruta'
      start.appendChild(startImg)
      start.appendChild(textStart)


      let end = L.DomUtil.create('li','list-group-item li-item')
      let textEnd = L.DomUtil.create('span','li-content-text')
      let endImg = L.DomUtil.create('img', 'li-content-icon')
      endImg.src = (location.port === '8080') ? '../src/assets/img/end.svg' : 'assets/img/end.svg'
      endImg.style.width = '30px'
      textEnd.innerText = 'Nodo de fin de ruta'
      end.appendChild(endImg)
      end.appendChild(textEnd)

      let stop = L.DomUtil.create('li','list-group-item li-item')
      let textStop = L.DomUtil.create('span','li-content-text')
      let stopImg = L.DomUtil.create('img', 'li-content-icon')
      stopImg.src = (location.port === '8080') ? '../src/assets/img/bus.svg' : 'assets/img/bus.svg'
      stopImg.style.width = '30px'
      textStop.innerText = 'Parada de autobus'
      stop.appendChild(stopImg)
      stop.appendChild(textStop)

      let station = L.DomUtil.create('li','list-group-item li-item')
      let textStation = L.DomUtil.create('span','li-content-text')
      let stationImg = L.DomUtil.create('img', 'li-content-icon')
      stationImg.src = (location.port === '8080') ? '../src/assets/img/station.svg' : 'assets/img/station.svg'
      stationImg.style.width = '30px'
      textStation.innerText = 'Estación de cercanias'
      station.appendChild(stationImg)
      station.appendChild(textStation)

      let normalRoute = L.DomUtil.create('li','list-group-item li-item')
      let textNormal = L.DomUtil.create('span','li-content-text')
      let normalImg = L.DomUtil.create('span', 'li-content-icon')

      normalImg.style.width = '50px'
      normalImg.style.height = '5px'
      normalImg.style.backgroundColor = '#ff7800'
      textNormal.innerText = 'Senderos Saludables'
      normalRoute.appendChild(normalImg)
      normalRoute.appendChild(textNormal)

      let shortRoute = L.DomUtil.create('li','list-group-item li-item')
      let textShort = L.DomUtil.create('span','li-content-text')
      let shortImg = L.DomUtil.create('span', 'li-content-icon')

      shortImg.style.width = '50px'
      shortImg.style.height = '5px'
      shortImg.style.backgroundColor = '#ff0000'
      textShort.innerText = 'Recorrido propuesto'
      shortRoute.appendChild(shortImg)
      shortRoute.appendChild(textShort)


      let busLine = L.DomUtil.create('li','list-group-item li-item')
      let textLine = L.DomUtil.create('span','li-content-text')
      let lineImg = L.DomUtil.create('span', 'li-content-icon')

      lineImg.style.width = '50px'
      lineImg.style.height = '5px'
      lineImg.style.backgroundColor = '#00ff00'
      textLine.innerText = 'Recorrido del autobús'
      busLine.appendChild(lineImg)
      busLine.appendChild(textLine)

      list.appendChild(nodes)
      list.appendChild(start)
      list.appendChild(end)
      list.appendChild(stop)
      list.appendChild(station)
      list.appendChild(normalRoute)
      list.appendChild(shortRoute)
      list.appendChild(busLine)


      let img = L.DomUtil.create('img', 'interrogante')

      img.src = (location.port === '8080') ? '../src/assets/img/interrogante.svg' : 'assets/img/interrogante.svg'
      img.style.width = '30px'

      img.onclick = ()=>{
        if(status)
          infoContent.classList.remove('oculto')
        else
          infoContent.classList.add('oculto')
        status = !status
      }

      infoContent.appendChild(list)
      container.appendChild(infoContent)
      container.appendChild(img)
      return container;
    }

  })
  return new custom()
}



// WEBPACK FOOTER //
// ./src/_helpers/legend.helper.js